import { Fragment, useEffect, useState } from 'react';
import { useGo } from '../../app/navigation';
import { useSubPath } from '../../app/useSubPath';
import { songById } from '../../content/songs';
import { ExerciseRunner } from '../exercise/ExerciseRunner';
import { LessonPage } from '../lesson/LessonPage';
import { challengeCards, challengeConfig } from '../levels';
import { GroupTitle, LessonList, LevelGrid, ModulePage, type TabDef } from '../module/ModulePage';
import { PlayAlong } from '../songs/PlayAlong';
import { SongList } from '../songs/SongList';
import { SongPage } from '../songs/SongPage';
import { CHALLENGES, EX_GROUPS, LEVELS, levelConfig } from './levels';

type Tab = 'dersler' | 'antrenman' | 'sarkilar' | 'meydan';
const TABS: TabDef<Tab>[] = [
  { id: 'dersler', label: 'Dersler', icon: 'book' },
  { id: 'antrenman', label: 'Antrenman', icon: 'target' },
  { id: 'sarkilar', label: 'Şarkılar', icon: 'note' },
  { id: 'meydan', label: 'Meydan okuma', icon: 'trophy' },
];

function SongRoute({ id, mode }: { id: string; mode?: string }) {
  const go = useGo();
  const song = songById(id);
  const [resets, setResets] = useState(0);
  useEffect(() => {
    if (!song) go('akor.sarkilar');
  }, [song, go]);
  if (!song) return null;
  return mode === 'birlikte' ? (
    <PlayAlong song={song} />
  ) : (
    <SongPage key={resets} song={song} onReset={() => setResets((n) => n + 1)} />
  );
}

export function AkorSection() {
  const [sub, a, b] = useSubPath();
  if (sub === 'ders') return <LessonPage module="akor" id={a ?? ''} />;
  if (sub === 'egz') {
    const level = LEVELS.find((l) => l.group.id === a && String(l.n) === b);
    if (level) return <ExerciseRunner config={() => levelConfig(level)} />;
  }
  if (sub === 'meydan' && a) {
    const ch = CHALLENGES.find((c) => c.id === a);
    if (ch) return <ExerciseRunner config={() => challengeConfig('akor', ch)} />;
  }
  if (sub === 'sarki' && a) return <SongRoute id={a} mode={b} />;
  const tab: Tab = sub === 'antrenman' || sub === 'sarkilar' || sub === 'meydan' ? sub : 'dersler';
  return (
    <ModulePage id="akor" levels={LEVELS} tabs={TABS} active={tab}>
      {tab === 'dersler' ? (
        <>
          <GroupTitle title="Önce öğren" sub="Solo kulağını akor kulağına çevir: kök, tür, derece ve dizi." />
          <LessonList module="akor" />
        </>
      ) : tab === 'antrenman' ? (
        EX_GROUPS.map((g) => (
          <Fragment key={g.id}>
            <GroupTitle title={g.title} sub={g.sub} />
            <LevelGrid items={g.levels} />
          </Fragment>
        ))
      ) : tab === 'sarkilar' ? (
        <SongList />
      ) : (
        <>
          <GroupTitle title="Meydan okumalar" sub="Hızlı akor tanıma ve dizi çıkarma." />
          <LevelGrid items={challengeCards(CHALLENGES)} />
        </>
      )}
    </ModulePage>
  );
}
